module.exports = __webpack_public_path__ + "static/media/thumbnail_paragard-information@2x.d9d44e59.jpg";